import React from 'react';
import bazar from '../image/bazar.png'
import download from '../image/file_download.png'

const DownloadPage = () => {
    return (
        <section id="main-section"
                 className="download_sec d-flex align-items-center justify-content-center text-light font-link ">
            <div>
                <div id="content" className="">
                    <h1 className="pt-5">MedMe</h1>
                    <h3>Medical Doctor Just For Me</h3>
                    <h3>با مِدمی یک پزشک همیشه همراه شماست</h3>
                    <h4 className="p-5 text-center font-link">برنامه "مِدمی" یک برنامه سلامت محور می باشد که در راستای افزایش بهره
                        سلامت جامعه قدم بر می دارد. این برنامه در حال حاضر شامل سه بخش می باشد. که در بخش اول محتوای
                        مفید سلامت و پزشکی که توسط پزشکان متخصص تهیه شده اند، به مخاطب ارایه می شود. در بخش دوم این
                        برنامه بیمار می تواند از یک دستیار ربات که بر پایه الگوریتم های پزشکی بنا شده است، یک ویزیت با
                        هوش مصنوعی را تجربه کند و به یک تشخیص اولیه نسبت به شرح حال خود برسدو گرچه این تشخیص در حال حاضر
                        قطعی نیست و تایید و یا رد آن نیاز به مراجعه حضوری بیمار به پزشک متخصص دارد. همینطور در بخش سوم
                        کاربر می تواند روند های تشخیصی ذخیره شده خود را ببیند و یا آنها را در مراجعه حضوری به پزشک خود
                        نشان دهد. این برنامه قصد دارد با گرفتن شرح حال دقیق و منظم از کاربر، به تشخیص بهتر موارد مربوط
                        به سلامتی هم به کاربر و هم به پزشک کمک کند. تیم توسعه فراد امیدوار است که به این مهم دست پیدا
                        کند. سلامتی و تندرستی همه افراد جامعه آرزوی قلبی ما در "فراد" است.</h4>
                    <br/>
                    <br/>
                    <p>در پایین، سه لینک برای دانلود این برنامه گذاشته شده است.</p>
                    <br/>
                    <br/>
                    <h5>نرم افزار اندروید</h5>

                    <div className="d-flex align-items-center justify-content-center p-3 text-dark">
                        <a target="_blank" className="download-button p-3 m-3" href="https://faraad.org/medme.apk" style={{ width: '250px', height: '70px' }}><img style={{ width: '50px', height: '40px' }} src={download}
                                                                                                   alt="download"/> دانلود
                            مستقیم </a>
                        {/*<a target="_blank" className="download-button" href="https://cafebazaar.ir/app/ir.farzademadi.medmeapp" style={{ width: '250px', height: '70px' }}><img style={{ width: '200px', height: '70px' }} className="p-1" src={bazar}
                                                                                            alt="cafeBazar"/></a>*/}

                        <a className="download-button m-3" target="_blank" href="https://myket.ir/app/ir.farzademadi.medmeapp?utm_source=search-ads-gift&utm_medium=cpc" style={{ width: '250px', height: '70px' }}><img style={{ width: '200px', height: '70px' }} className=""  src="https://myket.ir/core/images/logo/get1-fa.png" /> </a>
                    </div>

                </div>
            </div>
        </section>

    );
};

export default DownloadPage;